import * as React from "react";

const SvgRefresh = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="24px"
    height="24px"
    {...props}
  >
    <g>
      <polygon points="320.87 93.38 302.5 75 303.63 129.19 290.88 141.98 236.63 140.92 255 159.29 322.19 160.51 320.87 93.38" />
      <polygon points="77.69 306.89 96.07 325.26 94.93 271.07 107.68 258.29 161.93 259.35 143.56 240.98 76.38 239.75 77.69 306.89" />
      <path d="M200,92a108.09,108.09,0,0,1,95,56.67h20.06A126.18,126.18,0,0,0,200,74C137.56,74,85.59,119.66,75.7,179.33H94A108.18,108.18,0,0,1,200,92Z" />
      <path d="M200,308a108.09,108.09,0,0,1-95-56.67H84.94A126.18,126.18,0,0,0,200,326c62.44,0,114.41-45.66,124.3-105.33H306A108.18,108.18,0,0,1,200,308Z" />
    </g>
  </svg>
);

export default SvgRefresh;
